import { RefreshCw } from "lucide-react";
import { type ReactNode, useEffect, useState } from "react";

declare const __BUILD_ID__: string;

export function UpdateNotice({ children }: { children: ReactNode }) {
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    let active = true;
    const check = async () => {
      try {
        const response = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
        if (!response.ok) return;
        const version = await response.json() as { buildId?: string };
        if (active && version.buildId && version.buildId !== __BUILD_ID__) setAvailable(true);
      } catch { /* Keep the current session working through temporary network failures. */ }
    };
    const visibility = () => { if (document.visibilityState === "visible") void check(); };
    void check();
    const timer = window.setInterval(() => void check(), 60_000);
    document.addEventListener("visibilitychange", visibility);
    return () => { active = false; window.clearInterval(timer); document.removeEventListener("visibilitychange", visibility); };
  }, []);
  return <>{available && <div className="update-notice" role="status"><div><strong>Actualización disponible · Update available</strong><span>Actualice para usar la versión más reciente. · Refresh to use the latest version.</span></div><button onClick={() => window.location.reload()}><RefreshCw />Actualizar · Refresh</button></div>}{children}</>;
}
